import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import Typography from '@hellodarwin/core/lib/components/common/typography';
import Close from '@hellodarwin/icons/dist/icons/Close';
import { useTheme } from 'styled-components';
import { contextBadgeCloseStyle, contextBadgeLinkStyle, ContextBadgeContainer, ContextBadgeContent, getContextBadgeColors, } from './styles';
export const ContextBadge = ({ icon, label, value, href, onClear, variant = 'company', }) => {
    const theme = useTheme();
    const colors = getContextBadgeColors(theme, variant);
    const handleClick = () => {
        if (href) {
            window.open(href, '_blank');
        }
    };
    return (_jsxs(ContextBadgeContainer, { "$variant": variant, children: [_jsxs(ContextBadgeContent, { children: [icon, label ? (_jsxs(Typography, { elementTheme: "caption", color: theme.colors.grey_2, children: [label, ":"] })) : null, _jsx(Typography, { elementTheme: "caption", bold: true, color: colors.value, onClick: handleClick, style: href ? contextBadgeLinkStyle : undefined, children: value })] }), onClear && (_jsx(Close, { size: theme.spacing.md, color: theme.colors.grey_3, style: contextBadgeCloseStyle, onClick: onClear }))] }));
};
export default ContextBadge;
